import { client } from 'pioneira-ui';
import { storeMixins_prepareSearchText } from '../../mixins/storeMixins';

export default {
  namespaced: true,
  state: {
    activeTab: 0,
    aguardandoQrCode: false,
    proposta: {},
  },
  mutations: {
    SET_ACTIVE_TAB(state, value) {
      state.activeTab = value;
    },

    SET_PROPOSTA(state, data) {
      state.proposta = data;
    },

    SET_AGUARDANDO_QR_CODE(state, value) {
      state.aguardandoQrCode = value;
    },

    UPDATE_PROPONENTE(state, proponente) {
      state.proposta.proponente = proponente;
    },

    CLEAR_PROPOSTA(state) {
      state.proposta = {};
    },

    ALTERAR_SITUACAO_PARCEIRO(state, novaSituacao) {
      state.proposta.situacao_parceiro = novaSituacao;
    },

    REMOVER_SOLICITACAO_REENVIO_TAREFA(state, tarefaId) {
      const indexTarefa = state.proposta.tarefas.findIndex(
        (element) => element.id == tarefaId
      );
      const tarefa = state.proposta.tarefas[indexTarefa];
      tarefa.situacao = 'a_fazer';
      tarefa.solicitar_reenvio = false;
    },
  },
  actions: {
    changeTab({ commit }, value) {
      commit('SET_ACTIVE_TAB', value);
    },

    setProposta({ commit }, data) {
      commit('SET_PROPOSTA', data);
    },

    setAguardandoQrCode({ commit }, value) {
      commit('SET_AGUARDANDO_QR_CODE', value);
    },

    getAllPropostas(
      context,
      {
        pagina,
        porPagina,
        pesquisa,
        cpf,
        dataValidadeSimulacao,
        situacaoProposta,
      }
    ) {
      let parametros = `?pagina=${pagina || '1'}`;

      parametros += `&porPagina=${porPagina || '10'}`;
      parametros += pesquisa
        ? `&pesquisa=${storeMixins_prepareSearchText(pesquisa)}`
        : '';
      parametros += cpf ? `&cpf=${cpf}` : '';
      parametros += dataValidadeSimulacao
        ? `&dataValidadeSimulacao=${dataValidadeSimulacao}`
        : '';
      parametros += situacaoProposta
        ? `&situacaoProposta=${situacaoProposta}`
        : '';

      return client.get(`/api/simulacoes/listagem${parametros}`);
    },

    async atualizarDadosProponente({ state, commit }) {
      const { data } = await client.get(
        `/api/contratacao/proposta/${state.proposta.id}`
      );
      const proposta = data.data;
      if (proposta && proposta.proponente) {
        commit('UPDATE_PROPONENTE', proposta.proponente);
      }
    },

    async getPropostaContratacaoNaoAssociadoById({ dispatch }, id) {
      // obtendo proposta do não associado
      const { data } = await client.get(`/api/contratacao/proposta/${id}`);
      const proposta = data.data;

      if (!proposta.proponente.endereco_pessoal_id) {
        // add endereco novos dados para o não associado
        const EnderecoData = {
          cep: '',
          logradouro: null,
          numero: null,
          complemento: null,
          bairro: null,
          cidade: {
            id: null,
            nome: null,
            estado: {
              id: null,
              nome: null,
            },
          },
        };
        proposta.proponente.endereco_pessoal = EnderecoData;
      }

      if (!proposta.proponente.empresa_atividade_profissional_id) {
        // add empresa novos dados para o não associado
        const EmpresaData = {
          cnpj: '',
          nome: null,
          telefone: '',
          endereco: {
            cep: '',
            bairro: null,
            complemento: null,
            logradouro: null,
            numero: null,
            cnpj: null,
            cidade: {
              id: null,
              nome: null,
              estado: {
                id: null,
                nome: null,
              },
            },
          },
        };
        proposta.proponente.empresa_atividade_profissional.dados = EmpresaData;
      }

      if (!proposta.referencias.length) {
        // add referencias novos dados para o não associado
        const ReferenciasData = [
          {
            nome: null,
            vinculo: null,
            telefone: '',
          },
          {
            nome: null,
            vinculo: null,
            telefone: '',
          },
        ];
        proposta.referencias = ReferenciasData;
      }

      if (proposta.json_data_salvar_e_continuar_depois) {
        const parsedData = JSON.parse(
          proposta.json_data_salvar_e_continuar_depois
        );

        proposta.proponente = parsedData.proponente;
        proposta.veiculo = parsedData.veiculo;
        proposta.referencias = parsedData.referencias;
      }

      dispatch('setProposta', proposta);
    },

    getHistoricoByPropostaId({ state }) {
      return client.get(`/api/historico/proposta/${state.proposta.id}`);
    },

    updatePropostaContratacaoNaoAssociado({ state }) {
      delete state.proposta.anexos;

      let proponente = Object.assign({}, state.proposta.proponente);

      if (proponente.estado_civil !== 'solteiro') {
        proponente.uniao_estavel = null;
        proponente.uniao_estavel_label = null;
      }

      if (proponente.estado_civil !== 'casado') {
        proponente.tipo_uniao = null;
        proponente.tipo_uniao_label = null;
        proponente.cpf_conjuge = null;
        proponente.nome_conjuge = null;
      }

      // condicional para verificar se a proposta esta sendo editada ou se ela e nova
      if (proponente.empresa_atividade_profissional_id) {
        delete proponente.empresa_atividade_profissional.dados.id;
        proponente.empresa_atividade_profissional_id = null;
        proponente.empresa_atividade_profissional.endereco = null;
        proponente.empresa_atividade_profissional.estado_id = null;
      }

      let cidade_id = state.proposta.proponente.endereco_pessoal.cidade.id;
      delete proponente.endereco_pessoal.cidade;
      proponente.endereco_pessoal.cidade = { id: cidade_id };

      return client.patch(`/api/contratacao/update-proposta-nao-associado`, {
        id: state.proposta.id,
        proponente: proponente,
        referencias: state.proposta.referencias,
      });
    },

    updatePropostaJsonSalvarContinuarDepois({ state }) {
      const dataToSave = {};
      dataToSave.proponente = state.proposta.proponente;
      dataToSave.veiculo = state.proposta.veiculo;
      dataToSave.referencias = state.proposta.referencias;

      const data = {
        json_data_salvar_e_continuar_depois: JSON.stringify(dataToSave),
      };

      return client.patch(
        `/api/contratacao/update-proposta-json-salvar-continuar-depois/${state.proposta.id}`,
        data
      );
    },

    updateCnhProponente({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/proponente/cnh`,
        {
          nome: state.proposta.proponente.nome,
          rg_documento: state.proposta.proponente.rg_documento,
          rg_orgao_emissor: state.proposta.proponente.rg_orgao_emissor,
          rg_uf: state.proposta.proponente.rg_uf,
          cpf: state.proposta.proponente.cpf,
          data_nascimento: state.proposta.proponente.data_nascimento,
          filiacao_pai: state.proposta.proponente.filiacao_pai,
          filiacao_mae: state.proposta.proponente.filiacao_mae,
          cnh_categoria: state.proposta.proponente.cnh_categoria,
          cnh_registro: state.proposta.proponente.cnh_registro,
          cnh_data_validade: state.proposta.proponente.cnh_data_validade,
          cnh_data_primeira_habilitacao:
            state.proposta.proponente.cnh_data_primeira_habilitacao,
          cnh_local: state.proposta.proponente.cnh_local,
          cnh_data_emissao: state.proposta.proponente.cnh_data_emissao,
        }
      );
    },

    updateToPendenteDocs({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/to-pendente-docs`
      );
    },

    updateBackToPendenteDocs({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/back-to-pendente-docs`
      );
    },

    confirmDocsProponente({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/proponente/docs/confirm`
      );
    },

    updateToPendenteAss({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/to-pendente-assinatura`
      );
    },

    updateBackToPendenteAss({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/back-to-pendente-ass`
      );
    },

    confirmAssinaturaContrato({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/proponente/assinatura/confirm`
      );
    },

    pularAssinaturaContrato({ state }) {
      if (JSON.parse(process.env.VUE_APP_MOCKED_SIGNATURE)) {
        return client.put(`api/proposta/${state.proposta.id}/pular-assinatura`);
      }
    },

    gerarLinkAssinaturaContrato(
      { state },
      { telefone, email, tipoEnvio, tipoAssinatura }
    ) {
      return client.post(`/api/proposta/${state.proposta.id}/assinar`, {
        telefone,
        email,
        tipoEnvio,
        tipoAssinatura,
      });
    },

    solicitarPagamento({ state }, dados) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/pagamento/solicitar`,
        dados
      );
    },

    confirmAssinaturaEDocs({ state }) {
      return client.patch(
        `/api/acompanhamento/proposta/${state.proposta.id}/proponente/assinatura-docs/confirm`,
        {
          situacao: "pendente_solicitar_pagamento"
        }
      );
    },

    alterarSituacaoParceiro({ commit }, novaSituacao) {
      commit('ALTERAR_SITUACAO_PARCEIRO', novaSituacao);
    },

    updatePropostaAcompanhamento({ state }) {
      return client.patch(`/api/acompanhamento/proposta/${state.proposta.id}`, {
        veiculo: {
          chassi: state.proposta.veiculo.chassi,
        },
      });
    },

    async storeAnexoProposta({ state, dispatch }, data) {
      const formData = new FormData();
      formData.append('tipo', data.ref);
      formData.append('arquivo', data.file);

      const response = await client.post(
        `/api/proposta/${state.proposta.id}/anexo`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      dispatch('removerSolicitacaoReenvioParaTarefa', 'documento_veiculo');

      return response;
    },

    removerSolicitacaoReenvioParaTarefa({ state, commit }, nome_tarefa) {
      let tarefaId = 0;

      state.proposta.tarefas.forEach((element) => {
        if (element.tarefa === nome_tarefa) {
          tarefaId = element.id;
        }
      });

      if (state.proposta.situacao_parceiro == 'devolucao_ajuste') {
        commit('REMOVER_SOLICITACAO_REENVIO_TAREFA', tarefaId);
      }
    },

    deleteAnexoProposta(context, id) {
      return client.delete(`/api/proposta/anexo/${id}`);
    },

    downloadAnexoProposta(context, data) {
      return client.get(`/api/proposta/${data.proposta}/anexo/${data.anexo}`);
    },

    clearProposta({ commit }) {
      commit('CLEAR_PROPOSTA');
    },

    async getProposta({ state }) {
      const { data } = await client.get(
        `/api/contratacao/proposta/${state.proposta.id}`
      );

      return data.data;
    },
  },
};
